import {mod} from 'utils'

export const MONTH_PERIOD = 12
export const HOUR_PERIOD = 24

export const rectToCells = (rect) => {
    if (!rect) return []
    const unique = new Set()
    for (let month = rect.monthStart; month <= rect.monthEnd; month++) {
        for (let hour = rect.hourStart; hour <= rect.hourEnd; hour++) {
            unique.add(`${mod(month, MONTH_PERIOD)}:${mod(hour, HOUR_PERIOD)}`)
        }
    }
    return Array.from(unique)
}

export const formatHour = (hour) => `${String(hour).padStart(2, '0')}:00`

export const getRateMonthsHours = (rate = {}) => {
    let months = []
    if (Array.isArray(rate.months) && rate.months.length > 0) {
        months = rate.months
    } else if (rate.monthStart && rate.monthEnd) {
        months = Array.from(
            {length: rate.monthEnd - rate.monthStart + 1},
            (_, idx) => rate.monthStart + idx
        )
    }
    months = Array.from(
        new Set(months.map((month) => Number(month)).filter((month) => Number.isFinite(month)))
    ).sort((a, b) => a - b)

    let hours = []
    if (Array.isArray(rate.hours) && rate.hours.length > 0) {
        hours = rate.hours
    } else if (rate.hourStart !== undefined && rate.hourEnd !== undefined) {
        hours = Array.from(
            {length: rate.hourEnd - rate.hourStart + 1},
            (_, idx) => rate.hourStart + idx
        )
    }
    hours = Array.from(
        new Set(hours.map((hour) => Number(hour)).filter((hour) => Number.isFinite(hour)))
    ).sort((a, b) => a - b)

    return {months, hours}
}
